module.exports = __webpack_public_path__ + "img/4.811c90a3.jpg";